<template>
<div>
	<edit-container 
		ref="editContainer"
		type="car"
		:handle="['add','replace']"
		type-name="车辆"
		data-key="carNumber"
		@add="add"
		@replace="replace"
		@set-data="setData">
		<SchemeTable type="car" slot="thead"/>
	</edit-container>
	
	<Modal
		v-model="addShow"
		title="添加车辆"
        width="400px"
        :mask-closable="false">
		<Form :model="addForm" ref="addForm" :label-width="100" :rules="addFormRules">
			<FormItem label="车牌号" prop="carNumber">
		        <Input type="text" v-model="addForm.carNumber" ></Input>
		    </FormItem>
		    <FormItem label="发动机号" prop="engineNumber">
		        <Input type="text" v-model="addForm.engineNumber" ></Input>
		    </FormItem>
		    <FormItem label="车架号" prop="frameNumber">
		        <Input type="text" v-model="addForm.frameNumber" ></Input>
		    </FormItem>
		    <FormItem label="座位数" prop="seatingCapacity">
		        <Select v-model="addForm.seatingCapacity">
					<Option value="1">1</Option>
					<Option value="2">2</Option>
					<Option value="3">3</Option>
				</Select>
		    </FormItem>
		    <FormItem label="上传车辆行驶证：" class="mt15" required>
				<Row>
					<Col span="12">
						<FormItem prop="drivingLicensePhotoFront">
							<UploadFileImg 
								@on-success="val=>uploadSuccess(val,'drivingLicensePhotoFront','addForm')" 
								:accept="['image']"
								class="upload-item">
								<div class="upload-item-content" v-if="!addForm.drivingLicensePhotoFront">
									<Icon type="ios-camera" size="20"></Icon>
									<p>第一页</p>
								</div>
								<img 
									:src="ossImg(addForm.drivingLicensePhotoFront,'s')" 
									v-show="addForm.drivingLicensePhotoFront" 
									width="100%" 
									style="display:block" />
							</UploadFileImg>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem prop="drivingLicensePhotoEnd">
							<UploadFileImg 
								@on-success="val=>uploadSuccess(val,'drivingLicensePhotoEnd','addForm')" 
								:accept="['image']"
								class="upload-item">
								<div class="upload-item-content" v-if="!addForm.drivingLicensePhotoEnd">
									<Icon type="ios-camera" size="20"></Icon>
									<p>第二页</p>
								</div>
								<img 
									:src="ossImg(addForm.drivingLicensePhotoEnd,'s')" 
									v-show="addForm.drivingLicensePhotoEnd" 
									width="100%" 
									style="display:block" />
							</UploadFileImg>
						</FormItem>
					</Col>
				</Row>
			</FormItem>
		</Form>
		<template slot="footer">
			<Button type="text" @click="addShow=false">取消</Button>
			<Button type="primary" @click="confirmAdd" >确定</Button>
		</template>
	</Modal>
	
	<Modal
		v-model="replaceShow"
		title="车辆替换"
        :mask-closable="false">
		<Card title="原车辆">
			<Form :label-width="90">
				<FormItem label="车牌号：" class="mb0">
					{{replaceData.carNumber}}
				</FormItem>
				<FormItem label="保障方案：" class="mb0">
					{{replaceData.scheme}}
				</FormItem>
			</Form>
		</Card>
		<Card title="替换后车辆">
			<Alert type="warning">保障方案同被替换车辆一致</Alert>
			<Form :model="replaceForm" ref="replaceForm" :label-width="100" :rules="replaceFormRules">
				<FormItem label="车牌号" prop="carNumber">
					<Input type="text" v-model="replaceForm.carNumber" ></Input>
				</FormItem>
				<FormItem label="发动机号" prop="engineNumber">
					<Input type="text" v-model="replaceForm.engineNumber" ></Input>
				</FormItem>
				<FormItem label="车架号" prop="frameNumber">
					<Input type="text" v-model="replaceForm.frameNumber" ></Input>
				</FormItem>
				<FormItem label="上传车辆行驶证：" class="mt15" required>
					<Row>
						<Col span="12">
							<FormItem prop="drivingLicensePhotoFront">
								<UploadFileImg 
									@on-success="val=>uploadSuccess(val,'drivingLicensePhotoFront','replaceForm')" 
									:accept="['image']"
									class="upload-item">
									<div class="upload-item-content" v-if="!replaceForm.drivingLicensePhotoFront">
										<Icon type="ios-camera" size="20"></Icon>
										<p>第一页</p>
									</div>
									<img 
										:src="ossImg(replaceForm.drivingLicensePhotoFront,'s')" 
										v-show="replaceForm.drivingLicensePhotoFront" 
										width="100%" 
										style="display:block" />
								</UploadFileImg>
							</FormItem>
						</Col>
						<Col span="12">
							<FormItem prop="drivingLicensePhotoEnd">
								<UploadFileImg 
									@on-success="val=>uploadSuccess(val,'drivingLicensePhotoEnd','replaceForm')" 
									:accept="['image']"
									class="upload-item">
									<div class="upload-item-content" v-if="!replaceForm.drivingLicensePhotoEnd">
										<Icon type="ios-camera" size="20"></Icon>
										<p>第二页</p>
									</div>
									<img 
										:src="ossImg(replaceForm.drivingLicensePhotoEnd,'s')" 
										v-show="replaceForm.drivingLicensePhotoEnd" 
										width="100%" 
										style="display:block" />
								</UploadFileImg>
							</FormItem>
						</Col>
					</Row>
				</FormItem>
			</Form>
		</Card>
		
		<template slot="footer">
			<Button type="text" @click="replaceShow=false">取消</Button>
			<Button type="primary" @click="confirmReplace" >确定</Button>
		</template>
	</Modal>
</div>
</template>
<script>
import SchemeTable from '../common/SchemeTable'
import EditContainer from '@/pages/haierProduct/components/common/EditContainer'
import UploadFileImg from '@/components/common/UploadFileImg'
export default {
	components:{ SchemeTable,EditContainer,UploadFileImg },
	data () {
		return {
			list:[],
			addShow:false,
			addForm:{},
			addFormRules:{
				carNumber:{required:true,message:'请填写车牌号',trigger:'blur'},
				engineNumber:{required:true,message:'请填写发动机号',trigger:'blur'},
				frameNumber:{required:true,message:'请填写车架号',trigger:'blur'},
				seatingCapacity:{required:true,message:'请选择座位数',trigger:'change'},
				drivingLicensePhotoFront:{required:true,message:'请上传',trigger:'change'},
				drivingLicensePhotoEnd:{required:true,message:'请上传',trigger:'change'},
			},
			replaceShow:false,
			replaceData:{},
			replaceForm:{},
			replaceFormRules:{
				carNumber:{required:true,message:'请填写车牌号',trigger:'blur'},
				engineNumber:{required:true,message:'请填写发动机号',trigger:'blur'},
				frameNumber:{required:true,message:'请填写车架号',trigger:'blur'},
				drivingLicensePhotoFront:{required:true,message:'请上传',trigger:'change'},
				drivingLicensePhotoEnd:{required:true,message:'请上传',trigger:'change'},
			},
		}
	},
	created () {
	},
	methods:{
		setData(list) {
			this.list=list;
		},
        uploadSuccess(val,key,row){
			if(row=='addForm'){
				this.$set(this.addForm,key,val.url)
				this.$refs.addForm.validateField(key)
			}else{
				this.$set(this.replaceForm,key,val.url)
				this.$refs.replaceForm.validateField(key)
			}
        },
		// 添加
		add() {
			this.addShow=true;
			this.$refs.addForm.resetFields();
			this.addForm={
				operation:'ADD'
			};
		},
		// 确定
		confirmAdd(){
			this.$refs.addForm.validate(async valid=>{
				if(valid){
					let index=this.list.findIndex(item=>{
						return item.carNumber==this.addForm.carNumber&&item.operation!='REMOVE'
					})
					if(index!=-1){
						this.alert('此车牌号对应车辆已承保')
						return
					}
					let list=this.list.filter(item=>{
						return item.operation!='INIT'
					})
					list.push(this.addForm)
					await this.$refs.editContainer.getHandleList(list)
					this.addShow=false
				}
			})
		},
		// 打开替换
		replace(row) {
			this.replaceShow=true;
			this.$refs.replaceForm.resetFields();
			this.replaceData=row;
			this.replaceForm={
				no:row.no,
				seatingCapacity:row.seatingCapacity
			};
		},
		// 确定替换
		confirmReplace() {
			this.$refs.replaceForm.validate(async valid=>{
				if(valid){
					let index=this.list.findIndex(item=>{
						return item.carNumber==this.replaceForm.carNumber&&item.operation!='REMOVE'
					})
					if(index!=-1){
						this.alert('此车牌号对应车辆已承保')
						return
					}
					let list=this.list.filter(item=>{
						return item.operation!='INIT'
					})
					list.push({
						...this.replaceForm,
						operation:'REPLACE'
					})
					await this.$refs.editContainer.getHandleList(list)
					this.replaceShow=false;
				}
			})
		},
	}
}
</script>
<style scoped lang="less">
.mb0{
	margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/car/Edit.vue